module.exports = __webpack_public_path__ + "images/img-aPUHClU.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/ru/4.png
// module id = 2329
// module chunks = 0